/* ============================================================
   Blueminum Dealer Page JS
   Drop into assets/dealer.js
   ============================================================ */

(function() {
  if (window.__blueminum_dealer_initialized) return;

  const anyDealerSection = document.querySelector('.dealer-page');
  if (!anyDealerSection) return;

  window.__blueminum_dealer_initialized = true;

  // Multi-select checkbox cards — query the whole document so we catch
  // cards inside any dealer section wrapper, not just the first one.
  document.querySelectorAll('.dealer-checkbox-card').forEach(card => {
    const hiddenInput = card.querySelector('input[type="checkbox"]');

    function toggle() {
      const nowSelected = !card.classList.contains('selected');
      card.classList.toggle('selected', nowSelected);
      card.setAttribute('aria-checked', nowSelected ? 'true' : 'false');
      if (hiddenInput) hiddenInput.checked = nowSelected;
    }

    card.addEventListener('click', (e) => {
      e.preventDefault();
      toggle();
    });

    card.addEventListener('keydown', (e) => {
      if (e.key === ' ' || e.key === 'Enter') {
        e.preventDefault();
        toggle();
      }
    });
  });

  // FAQ accordion — same document-wide fix
  document.querySelectorAll('.dealer-faq-question').forEach(q => {
    q.addEventListener('click', () => {
      q.parentElement.classList.toggle('open');
    });
  });
})();